import { render } from "./ModalEditarPlanoPAP.vue?vue&type=template&id=6423c3a2&scoped=true"
import script from "./ModalEditarPlanoPAP.vue?vue&type=script&lang=js"
export * from "./ModalEditarPlanoPAP.vue?vue&type=script&lang=js"

import "./ModalEditarPlanoPAP.vue?vue&type=style&index=0&id=6423c3a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6423c3a2"]])

export default __exports__